import React, { Fragment, useState, useEffect } from "react";
import { getApi } from "../../api/endpoints";
import Multiselect from "multiselect-react-dropdown";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import ToggleSwitch from "../../components/ToggleSwitch";

const EnabledForRentalForm = (props) => {
  const {distributorDetails} = props;
  const [getServiceCentersApi] = getApi('serviceCenters');
  const [getFleetOwnersApi] = getApi('fleetOwners');
  const [enablePPForRentalApi] = getApi('enablePPForRental');
  const [disablePPForRentalApi] = getApi('disablePPForRental');
  const [serviceCenters, setServiceCenters] = useState();
  const [fleetOwners, setFleetOwners] = useState();
  const [serviceCenterId, setServiceCenterId] = useState("");
  const [cfoId, setCfoId] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const params = useParams();

  useEffect(() =>{
    if(!distributorDetails.enabled_for_rental){
      fetchApiData(getServiceCentersApi, "service_centers", { fields: 'options', filters: {rental: true} }, setServiceCenters);
      fetchApiData(getFleetOwnersApi, "fleet_owners", { fields: 'options', filters: {rental: true} }, setFleetOwners);
    }
  }, [distributorDetails.enabled_for_rental])

  const fetchApiData = async (api, key, params = {}, setFunction) => {
    try {
      const response = await api(params).unwrap();
      setFunction(response.data[key]);
    } catch (error) {
      toast.error(error.data.message || "Something Went Wrong while fetching data!");
    }
  }

  const onServiceCenterSelect = (selectedList, selectedItem) => {
    setServiceCenterId(selectedItem.id);
  }

  const onFleetOwnerSelect = (selectedList, selectedItem) => {
    setCfoId(selectedItem.id);
  }

  const onFormSubmit = async () => {
    try{
      if(serviceCenterId !== "" && cfoId !== ""){
        setErrorMsg("");
        let response = await enablePPForRentalApi({id: params.id, service_center_id: serviceCenterId, cfo_id: cfoId}).unwrap();
        distributorDetails.allocated_rental_fo = fleetOwners.filter((item) => item.id  === cfoId)[0];
        distributorDetails.allocated_rental_service_center =serviceCenters.filter(item => item.id === serviceCenterId)[0];
        distributorDetails.enabled_for_rental = true;
        toast.success(response.message);
        setServiceCenterId("");
        setCfoId("");
      } else {
        setErrorMsg("Please select all fields.");
      }
    } catch (error) {
      toast.error(error.data?.message || "Something went wrong !");
    }
  }

  const onToggle = async (event) => {
    try{
      let response = await disablePPForRentalApi({id: params.id}).unwrap();
      distributorDetails.enabled_for_rental = false;
      toast.success(response.message);
    } catch (error) {
      toast.error(error.data?.message || "Something went wrong !");
    }
  }

  return <Fragment>
    {distributorDetails.enabled_for_rental === false ?
    <>
      <h6 className="p-2">Enable/Disable For Rental</h6>
      <div className="row py-2 px-4">
        <div className="col-md-6 p-2">
          <label htmlFor="service_center_id" className="form-label">Select Service Center</label>
          <Multiselect
            id='service_center_id'
            options={serviceCenters}
            emptyRecordMsg={"Select Service Center"}
            singleSelect={true}
            displayValue='name'
            onSelect={(selectedList, selectedItem) => onServiceCenterSelect(selectedList, selectedItem)}
            showArrow={true}
            customArrow={true}
            avoidHighlightFirstOption={true}
          />
        </div>
        <div className="col-md-6 p-2">
          <label htmlFor="cfo_id" className="form-label">Select Fleet Owner</label>
          <Multiselect
            id='cfo_id'
            options={fleetOwners}
            emptyRecordMsg={"Select Fleet Owner"}
            singleSelect={true}
            displayValue='name'
            onSelect={(selectedList, selectedItem) => onFleetOwnerSelect(selectedList, selectedItem)}
            showArrow={true}
            customArrow={true}
            avoidHighlightFirstOption={true}
          />
        </div>
        {errorMsg !== "" && <div className="text-danger text-center">{errorMsg}</div>}
      </ div>
      <div className="d-flex justify-content-around mb-1">
        <button type="button" className="btn-submit" onClick={onFormSubmit}>Submit</button>
      </div>
    </>
    :
    <>
      <h6 className="p-2">Enable/Disable For Rental</h6>
      <div className="p-2">
        The distributor <span className="fst-italic fw-bold text-success">{props.distributorDetails?.name} </span>
        is associated with rental fleet owner <span className="fst-italic fw-bold text-success">{props.distributorDetails.allocated_rental_fo?.name} ({props.distributorDetails.allocated_rental_fo?.id}) </span>
        and associated with hub <span className="fst-italic fw-bold text-success">{props.distributorDetails.allocated_rental_service_center?.name}</span>.
      </div>
      <div className="p-2 d-flex justify-content-between">
        <label htmlFor="disable_for_rental" className="fw-medium pt-2">Enable For Rental</label>
        <ToggleSwitch
          id="disable_for_rental"
          label_left="No"
          label_right ="Yes"
          onChange={(e) => onToggle(e)}
          checked={distributorDetails.enabled_for_rental}
          defaultValue={true}
        />
      </div>
    </>
    }
  </Fragment>
}

export default EnabledForRentalForm;
